import { toast } from "react-toastify";
import Products from "../../../api/products";

export const products = {
  state: {
    products: [],
  },
  reducers: {
    setProducts(state, payload) {
      return {
        ...state,
        products: payload,
      };
    },
    clearStore() {
      return {};
    },
  },
  effects: (dispatch) => ({
    async loadAsync(payload, rootState) {
      const { onlyAvailable, idLoadType } = payload ?? {
        onlyAvailable: false,
        idLoadType: null,
      };
      try {
        const { data } = await Products.list(!!onlyAvailable, idLoadType);
        this.setProducts(data);
      } catch (error) {
        toast.error("Ops :( Algo deu errado !");
      }
    },
    async loadByPlantAsync(payload, rootState) {
      try {
        const { idLoadType, idPlant } = payload;
        const { data } = await Products.listByPlant(idLoadType, idPlant);
        this.setProducts(data);
      } catch (error) {
        toast.error("Ops :( Algo deu errado !");
      }
    },
  }),
};
